import { KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'

export default {
    name: 'kendo-panelbar-item',
    render (h) {
        return h('span',this.$slots.default)
    },
    mixins: [
        KendoSharedMethods
    ],
    props:{
        text: String,
        cssClass: String,
        url: String,
        encoded: Boolean,
        content: String,
        contentUrl: String,
        imageUrl: String,
        items: Array,
        expanded: Boolean,
        spriteCssClass: String
    },
    mounted() {
        this._resolveInnerChildren()
    },
    methods: {
        _resolveInnerChildren() {
            if(!this.$options.propsData['items'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-panelbar-item')
                this.subitems = items
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/KendoPanelBarItem.js